/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Card, CardBody, Row, Col, Label } from "reactstrap";
import ButtonComponent from "../../../../components/ButtonComponent";
import Select from "react-select";
import { CardHeader, Table, Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";
import {
  useLazyGetMenuItemListQuery,
  useUpdateSetMenuMutation,
  useUpdateSetMenuImageMutation,
  useUploadSetMenuLogoFileExtntionHttpsMutation,
} from "../../../../redux/services/setMenuService";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import ControlledRowTextField from "../../../../components/ControlledRowTextField";
import { toast } from "react-toastify";
import EditPhotoUpload from "../../../../components/EditPhotoUpload";
import {
  capitalizeFirstLetter,
  capitalizeFirstLetterEdit,
  customFilterOption,
} from "../../../../utility/Utility";
import { uploadImage } from "../../../../components/imageUploadCompont";
import ControlledSelect from "../../../../components/ControlledSelect";
import ControlledRowTextFieldForPortion from "../../../../components/RowTextFieldsForPortions";
import {
  useGetAllergenInformationQuery,
  useGetFoodAttributesListQuery,
  useLazyGetRestaurantFilterTagsQuery,
} from "../../../../redux/services/menuItemService";
import ControlledRowSelectPortion from "../../../../components/ControlledRowSelectPortion";
import { useLazyGetPortionSizesQuery } from "../../../../redux/services/CustomTypeService";
import { getImageUrl } from "../../../../dummyData/FoodAttributes";
import { useSelector } from "react-redux";
import React from "react";

const UpdateMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const stateSetMenu = location.state?.item;
  const RestID = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails.id
  );

  const reastaurantData = useSelector(
    (state: any) => state?.restaurant?.selectedRestaurantDetails
  );

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const [selectedOption, setSelectedOption] = useState<any>(null);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [isSaving, setIsSaving] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [portionErrorMessage, setPortionErrorMessage] = useState<string | null>(
    null
  );
  const [showImageUpdateModal, setShowImageUpdateModal] = useState(false);
  const [uploadedImgDetails, setUploadedImgDetails] = useState<{
    imgSrc: string;
    formData: any;
    fileExtension: string;
  }>({ imgSrc: "", formData: "", fileExtension: "" });
  const [isImageUpdateLoading, setIsImageUpdateLoading] = useState(false);
  const [duplicateItemError, setDuplicateItemError] = useState<string | null>(
    null
  );
  const [editMode, setEditMode] = useState(false);
  const [canPortion, setCanPortion] = useState(false);
  const [portionSize, setPortionSize] = useState("");
  const [portionPrice, setPortionPrice] = useState("");
  const [portions, setPortions] = useState<
    { displayName: string; additionalCost: number }[]
  >([]);

  const [updateSetMenu] = useUpdateSetMenuMutation();
  const [getSetMenuImageReference] =
    useUploadSetMenuLogoFileExtntionHttpsMutation();
  const [updateSetMenuImage] = useUpdateSetMenuImageMutation();
  const [triggerGetMenuItemList, { isLoading, data: menuItemsData }] =
    useLazyGetMenuItemListQuery();

  const menuCategories: any = reastaurantData?.categoryTags.map(
    (value: any) => {
      return {
        value: capitalizeFirstLetter(value),
        label: capitalizeFirstLetter(value),
      };
    }
  ) || [{ value: "", label: "" }];
  const [isPortionPriceDisable, setIsPortionPriceDisable] =
    useState<boolean>(false);
  const [triggerGetPortionSizes, { data: portionSizesData = [] }] =
    useLazyGetPortionSizesQuery();

  useEffect(() => {
    if (RestID) {
      triggerGetPortionSizes({ restaurantId: RestID });
    }
  }, [RestID, triggerGetPortionSizes]);

  const portionSizesOptions = portionSizesData.map((size) => ({
    value: size.portionSize,
    label: size.portionSize,
  }));

  const isPortionButtonDisabled = !portionSize || !portionPrice;

  const { data: allergenData } = useGetAllergenInformationQuery();
  const allergenOptions =
    allergenData?.allergenInformation.map((allergen) => ({
      value: allergen.displayName,
      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
          <img
            src={getImageUrl(allergen.displayName)}
            alt={allergen.displayName}
            width="20px"
            height="20px"
          />
          {allergen.displayName}
        </div>
      ),
    })) || [];

  const { data: foodAttributesData } = useGetFoodAttributesListQuery();
  useEffect(() => {
    const restaurantId =
      localStorage.getItem("selectedRestaurantId") || "ffffff";
  }, []);

  const foodAttributesOptions =
    foodAttributesData?.FoodAttributesList.map((attr) => ({
      value: attr.displayName,
      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
          <img
            src={getImageUrl(attr.displayName)}
            alt={attr.displayName}
            width="20px"
            height="20px"
          />
          {attr.displayName}
        </div>
      ),
    })) || [];

  useEffect(() => {
    if (stateSetMenu) {
      setValue("displayName", stateSetMenu.displayName, {
        shouldValidate: true,
      });
      setValue("abbreviation", stateSetMenu.abbreviation);
      setValue("description", stateSetMenu.description);
      const selectedCategory = menuCategories.find(
        (cat: any) => cat.value === stateSetMenu.category
      );
      setValue("category", selectedCategory || null);
      setValue("imageUrl", stateSetMenu.imageUrl);
      setValue("tinyId", stateSetMenu.tinyId || 0);
      setSelectedItems(stateSetMenu.items);
      setValue("productId", stateSetMenu.productId);
      setValue(
        "filterTags",
        stateSetMenu.tags
          ? Object.entries(
              stateSetMenu.tags as Record<string, string[]>
            ).flatMap(([category, tags]) =>
              tags.map((tag: string) => ({
                value: capitalizeFirstLetterEdit(tag),
                label: (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "left",
                      gap: "2%",
                    }}
                  >
                    {capitalizeFirstLetterEdit(tag)}
                  </div>
                ),
              }))
            )
          : []
      );

      setValue(
        "allergenInformation",
        (stateSetMenu.allergenInformation || []).map((allergen: string) => ({
          label: (
            <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
              <img
                src={getImageUrl(allergen)}
                alt={allergen}
                width="20px"
                height="20px"
              />
              {allergen}
            </div>
          ),
          value: capitalizeFirstLetterEdit(allergen),
        }))
      );
      setValue(
        "foodAttributes",
        (stateSetMenu.foodAttributes || []).map((attribute: string) => ({
          label: (
            <div style={{ display: "flex", justifyContent: "left", gap: "2%" }}>
              <img
                src={getImageUrl(attribute)}
                alt={attribute}
                width="20px"
                height="20px"
              />
              {attribute}
            </div>
          ),
          value: capitalizeFirstLetterEdit(attribute),
        }))
      );
      setCanPortion(stateSetMenu.supportPortionSizes || false);
      setValue(
        "supportsPreOrdering",
        stateSetMenu.supportsPreOrdering || false
      );
      setPortions(stateSetMenu.portions || []);
      if (stateSetMenu.portions) {
        setPortions(stateSetMenu.portions);
        if (stateSetMenu.portions.length > 0) {
          setPortionSize(stateSetMenu.portions[0]?.displayName || "");
          setPortionPrice(stateSetMenu.portions[0]?.price?.toString() || "");
        }
      } else {
        setPortions([]);
        setPortionSize("");
        setPortionPrice("");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateSetMenu, setValue]);

  useEffect(() => {
    const restaurantId = RestID;
    if (restaurantId) {
      triggerGetMenuItemList({ restaurantId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerGetMenuItemList]);

  const [
    triggerGetFilterTags,
    { data: filterTagsData, isLoading: isFilterTagsLoading },
  ] = useLazyGetRestaurantFilterTagsQuery();

  useEffect(() => {
    if (RestID) {
      triggerGetFilterTags(RestID);
    }
  }, [RestID, triggerGetFilterTags]);

  const filterTagsOptions = React.useMemo(() => {
    if (isFilterTagsLoading || !filterTagsData) return [];

    const options: { value: string; label: string }[] = [];

    // Iterate over each category in filterTags
    Object.entries(filterTagsData.filterTags).forEach(
      ([category, categoryData]) => {
        if (categoryData.tags && Array.isArray(categoryData.tags)) {
          categoryData.tags.forEach((tag) => {
            if (tag.show) {
              options.push({ value: tag.tag, label: `${tag.tag}` });
            }
          });
        }
      }
    );

    return options;
  }, [filterTagsData, isFilterTagsLoading]);

  const menuItemsOptions = menuItemsData
    ?.filter(
      (item: any) =>
        !selectedItems.some(
          (selectedItem) => selectedItem.value === item.itemId
        )
    )
    .map((item: any) => ({
      value: item.itemId,
      displayName: item.displayName,
      label: (
        <div style={{ display: "flex", justifyContent: "left", gap: "5%" }}>
          <img src={item.imageUrl} alt="item" width="30px" height="30px" />
          {item.displayName}
        </div>
      ),
      description: item.description,
      price: item.price,
      imageUrl: item.imageUrl,
    }));

  const handleEditButtonClick = () => {
    setEditMode(true);
  };

  const handleAdd = () => {
    if (selectedOption) {
      const itemExists = selectedItems.some(
        (item) => item.displayName === selectedOption.displayName
      );
      if (itemExists) {
        setDuplicateItemError("This menu item is already selected.");
        return;
      }
      const newItem = { ...selectedOption };
      setSelectedItems((prevItems) => [...prevItems, newItem]);
      setSelectedOption(null);
      setDuplicateItemError(null);
    }
  };

  const handleDelete = (index: number) => {
    const updatedItems = [...selectedItems];
    updatedItems.splice(index, 1);
    setSelectedItems(updatedItems);
  };

  const onSubmit = async (data: any) => {
    setIsSaving(true);
    if (selectedItems.length === 0) {
      setErrorMessage("Cannot save without adding any menu items");
      setIsSaving(false);
      return;
    }
    // Convert flat filterTags array to structured tags object
    const structuredTags: { [key: string]: string[] } = {};

    // Loop through selected tags and group by category
    if (filterTagsData?.filterTags && data.filterTags) {
      Object.entries(filterTagsData.filterTags).forEach(
        ([categoryKey, categoryData]) => {
          const selectedTags = (data.filterTags ?? [])
            .map((tag: any) => tag.value)
            .filter((tagValue: string) =>
              (categoryData.tags as any[]).some(
                (tagObj) => tagObj.tag === tagValue
              )
            );

          if (selectedTags.length > 0) {
            structuredTags[categoryKey.toLowerCase()] = selectedTags.map(
              (tag: string) => tag.toLowerCase()
            );
          }
        }
      );
    }
    const updateData = {
      // restaurantId: localStorage.getItem("selectedRestaurantId") || "",
      restaurantId: RestID,
      setMenuId: stateSetMenu.id,
      items: selectedItems.map((item) => ({
        menuItemId: item.menuItemId || item.value,
        description: item.description,
        imageUrl: item.imageUrl,
        displayName: item.displayName,
        price: item.price,
      })),
      description: data.description,
      displayName: data.displayName,
      tinyId: +data.tinyId || 0,
      abbreviation: data.abbreviation,
      category: data.category.value,
      allergenInformation: data?.allergenInformation?.map(
        (item: any) => item.value
      ),
      foodAttributes: data?.foodAttributes?.map((item: any) => item.value),
      supportPortionSizes: canPortion,
      portions: canPortion
        ? portions.map((portion) => ({
            displayName: portion.displayName || "",
            additionalCost: portion.additionalCost || 0,
          }))
        : [],
      tags: structuredTags,
      // filterTags: data?.filterTags?.map((item: any) => item.value),
      productId: data.productId,
      supportsPreOrdering: data.supportsPreOrdering,
    };

    try {
      const response: any = await updateSetMenu(updateData).unwrap();
      if (
        response?.error?.status === 409 &&
        response?.error?.data === "ProductId Already exists"
      ) {
        toast.error("ProductId Already exists");
        setIsSaving(false);
      } else {
        toast.success("Combo Menu Updated Successfully...");
        navigate("/productCatalogue/combo-menu");
        setErrorMessage(null);
      }
    } catch (error: any) {
      if (error.status === 409) {
        toast.error("Combo menu name is already exists");
        return;
      }
      toast.error("Something went wrong...");
    } finally {
      setIsSaving(false);
    }
  };

  const handleUpdatePhoto = () => {
    setShowImageUpdateModal(true);
  };

  const handleCloseModal = () => {
    setShowImageUpdateModal(false);
  };

  const imageUploadCallback = (e: any) => {
    setUploadedImgDetails({
      ...uploadedImgDetails,
      imgSrc: e.imgSrc,
      formData: e.formData,
      fileExtension: e.fileExtension,
    });
  };

  const handleSetMenuImageUpdate = async () => {
    setIsImageUpdateLoading(true);

    const imageRef = await uploadImage(getSetMenuImageReference, {
      fileExtention: uploadedImgDetails.fileExtension,
      formData: uploadedImgDetails.formData,
    });
    const updateImageResponse = await updateSetMenuImage({
      imgRef: imageRef,
      restaurantId: localStorage.getItem("selectedRestaurantId") || "",
      setMenuId: stateSetMenu.id,
    });
    if ("data" in updateImageResponse) {
      toast.success("Restaurant Image Successfully Updated");
      navigate("/productCatalogue/combo-menu");
    } else {
      toast.error("Something Went Wrong");
    }
    setIsImageUpdateLoading(false);
  };

  const handleCheckboxChangeForPortion = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCanPortion(event.target.checked);
  };

  const addPortion = () => {
    if (!portionSize) {
      setPortionErrorMessage("Please select a portion size.");
      return;
    }

    const portionExists = portions.some(
      (portion) => portion.displayName === portionSize
    );

    if (portionExists) {
      setPortionErrorMessage("Portion size is already added.");
    } else {
      const selectedPortion = portionSizesData.find(
        (size) => size.portionSize === portionSize
      );

      const portionSizeCost =
        selectedPortion &&
        selectedPortion.portionSize === portionSizesData[0]?.portionSize
          ? 0
          : Number(portionPrice);

      setPortions([
        ...portions,
        { displayName: portionSize, additionalCost: portionSizeCost },
      ]);

      setPortionSize("");
      setPortionPrice("");
      setValue("portionSize", "");
      setValue("portionPrice", 0);
      setPortionErrorMessage(null);
    }
  };

  const deletePortion = (index: number) => {
    const updatedPortions = portions.filter((_, i) => i !== index);
    setPortions(updatedPortions);
    setPortionErrorMessage(null);
  };

  const handleSelectPortion = (option: any) => {
    setPortionSize(option.value);

    if (option.value === portionSizesData[0].portionSize) {
      setValue("portionPrice", 0);
      setIsPortionPriceDisable(true);
    } else {
      setIsPortionPriceDisable(false);
    }
  };

  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card>
        <CardHeader
          style={{
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h4>Update Combo Menu</h4>
          <div>
            {!editMode && (
              <Button
                variant="light"
                type="button"
                onClick={handleEditButtonClick}
              >
                <FontAwesomeIcon icon={faEdit} title="Edit" color="#699BF7" />
              </Button>
            )}
          </div>
        </CardHeader>
        <CardBody>
          <form
            className="auth-login-form mt-2"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row>
              <Col lg="4">
                <Label>Combo Menu Photo</Label>
              </Col>
              <Col lg="8">
                <img
                  src={stateSetMenu.imageUrl}
                  alt="setmenuImage"
                  style={{
                    width: "30%",
                    height: "auto",
                    borderRadius: "30px",
                  }}
                />
                <Button
                  variant="danger"
                  size="sm"
                  onClick={handleUpdatePhoto}
                  style={{ position: "relative", top: "45%", right: "10%" }}
                  title="Edit Photo"
                  disabled={!editMode}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </Button>
              </Col>
            </Row>

            <Modal
              show={showImageUpdateModal}
              onHide={handleCloseModal}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Update Combo Menu Photo</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <EditPhotoUpload
                  imageUrl={uploadedImgDetails.imgSrc}
                  onUpload={imageUploadCallback}
                />
              </Modal.Body>
              <Modal.Footer>
                {isImageUpdateLoading ? (
                  <ButtonComponent
                    titel="Saving..."
                    type="button"
                    icon={<FontAwesomeIcon icon={faSpinner} spin />}
                    isDisabled={isImageUpdateLoading}
                    onClick={handleSetMenuImageUpdate}
                  />
                ) : (
                  <ButtonComponent
                    titel="Save"
                    type="button"
                    isDisabled={isImageUpdateLoading}
                    onClick={handleSetMenuImageUpdate}
                  />
                )}
              </Modal.Footer>
            </Modal>

            <hr />

            <ControlledRowTextField
              label={"Combo Menu Name"}
              inputName={"displayName"}
              inputType={"text"}
              placeholder={"Enter Combo Menu Name"}
              control={control}
              rules={{ required: "Combo Menu Name is required" }}
              isDisabled={!editMode}
            />
            {errors.displayName && (
              <span className="text-danger">
                {errors.displayName.message as string}
              </span>
            )}
            <hr />
            <ControlledRowTextField
              label={"Abbreviation"}
              inputName={"abbreviation"}
              inputType={"text"}
              placeholder={"Enter Abbreviation"}
              control={control}
              isDisabled={!editMode}
            />
            <hr />
            <ControlledRowTextField
              label={"Description"}
              inputName={"description"}
              inputType={"textarea"}
              placeholder={"Enter Description"}
              control={control}
              rules={{ required: "Combo Menu Description is required" }}
              isDisabled={!editMode}
            />
            {errors.description && (
              <span className="text-danger">
                {errors.description.message as string}
              </span>
            )}
            <hr />
            <ControlledRowTextField
              label={"Product ID"}
              inputName={"productId"}
              inputType={"text"}
              placeholder={"Enter Product ID"}
              control={control}
              isDisabled={!editMode}
            />

            <hr />
            <ControlledRowTextField
              label={"Tiny ID"}
              inputName={"tinyId"}
              inputType={"number"}
              placeholder={"Enter Tiny ID"}
              control={control}
              isDisabled={!editMode}
            />
            <hr />
            <ControlledSelect
              label={"Category"}
              inputName={"category"}
              control={control}
              isMulti={false}
              optionsList={menuCategories}
              rules={{ required: "Category is required" }}
              isDisabled={!editMode}
            />
            {errors.category && (
              <p className="text-danger">{errors.category.message as string}</p>
            )}
            <hr />
            <ControlledSelect
              label={"Allergen Information"}
              inputName={"allergenInformation"}
              control={control}
              isMulti={true}
              optionsList={allergenOptions}
              isDisabled={!editMode}
            />
            <hr />
            <ControlledSelect
              label={"Food Attributes"}
              inputName={"foodAttributes"}
              control={control}
              isMulti={true}
              optionsList={foodAttributesOptions}
              isDisabled={!editMode}
            />

            <hr />
            <ControlledSelect
              label={"Filter Tags"}
              inputName={"filterTags"}
              control={control}
              isMulti={true}
              optionsList={filterTagsOptions}
              isDisabled={!editMode}
            />
            <hr />
            <Row>
              <Col lg="4">
                <Label
                  className="form-check-label"
                  htmlFor="supportsPreOrdering"
                >
                  Supports Pre-Ordering
                </Label>
              </Col>
              <Col lg="8">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="supportsPreOrdering"
                  checked={watch("supportsPreOrdering")}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setValue("supportsPreOrdering", event.target.checked);
                  }}
                  disabled={!editMode}
                />
              </Col>
            </Row>
            <hr />
            <Row className="mb-3">
              <Col lg={4}>
                <Label>Portion Available</Label>
              </Col>
              <Col lg={8}>
                <input
                  type="checkbox"
                  checked={canPortion}
                  className="form-check-input"
                  onChange={handleCheckboxChangeForPortion}
                  disabled={!editMode}
                />
                <hr />
                {canPortion && (
                  <div className="portion-section">
                    <div className="portion-inputs">
                      <Row>
                        <Col md={5} className="mt-1">
                          <ControlledRowSelectPortion
                            inputName="portionSize"
                            control={control}
                            optionsList={portionSizesOptions}
                            placeholder="Select portion size"
                            onChange={(option: any) =>
                              // setPortionSize(option ? option.value : "")
                              handleSelectPortion(option)
                            }
                            isDisabled={!editMode}
                          />
                          <br />
                        </Col>

                        <Col md={5}>
                          <ControlledRowTextFieldForPortion
                            inputName={"portionPrice"}
                            inputType={"number"}
                            placeholder={"Enter portion price"}
                            control={control}
                            onChange={(e) => {
                              const value = Number(e.target.value);
                              if (value >= 0) {
                                setPortionPrice(e.target.value);
                              } else {
                                setPortionPrice("");
                                setPortionErrorMessage(
                                  "Portion price cannot be negative."
                                );
                              }
                            }}
                            // isDisabled={!editMode }
                            isDisabled={!editMode || isPortionPriceDisable}
                          />
                        </Col>

                        <Col md={2}>
                          <ButtonComponent
                            type="button"
                            titel="+Add"
                            // isDisabled={isPortionButtonDisabled || !editMode}
                            isDisabled={
                              (portionSizesData?.[0]?.portionSize ===
                              portionSize
                                ? false
                                : isPortionButtonDisabled) || !editMode
                            }
                            onClick={addPortion}
                          />
                        </Col>
                      </Row>
                    </div>
                    {portionErrorMessage && (
                      <p className="text-danger">{portionErrorMessage}</p>
                    )}
                    <Table>
                      <thead>
                        <tr>
                          <th>Size</th>
                          <th>Price</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {portions.map((portion, index) => (
                          <tr key={index}>
                            <td>{portion.displayName}</td>
                            <td>{portion.additionalCost}</td>
                            <td>
                              <Button
                                variant="light"
                                onClick={() => deletePortion(index)}
                                disabled={!editMode}
                              >
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  title="Delete"
                                  color="#F24E1E"
                                />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Col>
            </Row>
          </form>
        </CardBody>
      </Card>
      <Card className="mt-3">
        <CardBody>
          <Row className="align-items-center mt-3">
            <Col sm={10}>
              <Select
                value={selectedOption}
                onChange={setSelectedOption}
                options={menuItemsOptions}
                placeholder={isLoading ? "Loading..." : "Search menu item"}
                isSearchable
                isDisabled={!menuItemsOptions}
                loadingMessage={() => "Loading menu items..."}
                noOptionsMessage={() =>
                  isLoading ? "Loading..." : "No items found"
                }
                filterOption={customFilterOption}
              />
            </Col>
            <Col sm={2} className="text-right">
              <ButtonComponent
                titel="+Add"
                type={"button"}
                onClick={handleAdd}
                isDisabled={!selectedOption}
              />
            </Col>
          </Row>
          <hr />
          {duplicateItemError && (
            <div className="text-danger">{duplicateItemError}</div>
          )}
          <div className="selected-items-container">
            <h5>Selected Items</h5>
            <Table bordered className="mt-3" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Price (Rs.)</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {selectedItems.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex gap-3 align-items-center">
                        <img
                          src={item.imageUrl}
                          width="50px"
                          height="50px"
                          alt="itemphoto"
                        />
                        {item.displayName}
                      </div>
                    </td>
                    <td>{item.price}</td>
                    <td>
                      <Button
                        variant="light"
                        onClick={() => handleDelete(index)}
                        disabled={!editMode}
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          title="Delete"
                          color="#F24E1E"
                        />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {successMessage && (
            <div className="text-success mt-2">{successMessage}</div>
          )}
          {errorMessage && (
            <div className="text-danger mt-2">{errorMessage}</div>
          )}
          <div className="d-flex justify-content-end mt-4 mb-3">
            {isSaving ? (
              <ButtonComponent
                type="submit"
                icon={
                  <FontAwesomeIcon icon={faSpinner} spin title="Updating..." />
                }
                titel="Updating..."
                isDisabled={true}
              />
            ) : (
              <ButtonComponent
                titel="Update"
                type="submit"
                onClick={handleSubmit(onSubmit)}
                isDisabled={!editMode}
              />
            )}
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default UpdateMenu;
